const digest = 'ae231be07f43c5cb8015ebbee07795946d1b78cd174c9afeb181e274c061e853';
const css = `._monthEmptySpace_8tddr_1{height:3rem;width:3rem}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'monthEmptySpace': '_monthEmptySpace_8tddr_1' };
export const monthEmptySpace = '_monthEmptySpace_8tddr_1';
export { css, digest };